import { connect } from 'react-redux'
import { authActions } from 'store/user'
import { SITE_ROLE_IDS } from 'utils/constants'
import { getUserPermissionByStudyId, hasStudyPayments } from 'utils/misc'
import { fetchInsightsRedirectUrl } from './modules/SideBarRequests'
import SideBar from './SideBar'
import { getStudyVersionID, resolveRouteStudyId } from '../../utils/studyConfigUtils'
import { getStudyRoleInfo } from '../../routes/Studies/routes/CreateStudy/utils/studyUtils'

const navText = {
  studies: 'All Studies',
  audit: 'Audit Report',
}

const mapDispatchToProps = {
  onLogout: authActions.logout,
  onFetchInsightsRedirectUrl: fetchInsightsRedirectUrl,
}

const mapStateToProps = (state, ownProps) => {
  const {
    user,
    userReducer,
    study,
    subroute,
    location,
    sending,
    studies,
    modal,
    navBar,
    loading,
    paymentsReducer,
    studyLock,
    sideBarReducer,
    visitSchedules = {},
    sites = {},
  } = state
  const { currentStudy, studyVersionList = [] } = study

  const studyID = resolveRouteStudyId({
    location,
    paramsStudyID: ownProps?.params?.studyID,
    currentStudyId: currentStudy?.id,
  })

  const {
    studyVersionID: versionIDFromRole,
  } = getStudyRoleInfo(user?.permissions, studyID, studyVersionList)

  const studyVersionID = getStudyVersionID(location) || versionIDFromRole

  const selectedUser = userReducer ? userReducer.user.nickname : undefined
  const dropdownText =
    studies.length === 0 && navText[subroute] === 'studies'
      ? 'Create Study'
      : navText[subroute] || selectedUser || study.currentStudy.platform_name

  const { orphanedParticipants } = study
  const { sitesList = [] } = sites
  const { visitSchedulesPreviousList = [] } = visitSchedules
  const disabled = sending.sendingState || sending.sentState
  const studyPermission = getUserPermissionByStudyId(user, studyID)

  return {
    studyLock,
    loading: loading.general,
    insightsLoading: loading.insights,
    selectedUser,
    user,
    location,
    disabled,
    studies,
    modal,
    subroute,
    dropdownText,
    study: study.currentStudy,
    orphanedParticipants,
    showNavLinks: subroute !== 'studies' && subroute !== 'me' && subroute !== 'createStudy',
    navProps: navBar,
    hasPayments: hasStudyPayments(study.currentStudy),
    role: studyPermission?.name || '',
    roleId: studyPermission?.role_id,
    showPendingPaymentsNotification: paymentsReducer.pendingPaymentsNotification,
    loadingStudy: loading.studyConfig,
    sideBar: sideBarReducer,
    passedVisitsCount: visitSchedulesPreviousList?.filter(
      item => item.filter(rowData => rowData.key === 'status').map(obj => obj.value)?.[0] === 'confirm-occurence',
    )?.length,
    isPassedVisitsCountVisible: SITE_ROLE_IDS.includes(studyPermission?.role_id),
    sitesExist: !!sitesList?.length,
    studyID,
    studyVersionID,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)
